import React from 'react';
import VoxelButton, { VoxelButtonProps } from '../../Buttons/VoxelButton';


export interface VoxelFormPanelActionSubmitProps extends Omit<VoxelButtonProps, 'title'> {
  title?: string;
}

export const VoxelFormPanelActionSubmit: React.FC<VoxelFormPanelActionSubmitProps> = ({
  title = 'Submit',
  ...props
}) => {
  return <VoxelButton title={title} shape='square' color="primary" size="lg" type="submit" {...props} />;
};

export default VoxelFormPanelActionSubmit;
